import Service from "../../Service";

const resource = "tasalertdefinition/";

export default {
  tables(search, requestID) {
    return Service.post(resource + "tables", {}, {
      params: { search: search || "", requestID },
    });
  },
  columns(table, requestID) {
    return Service.post(resource + "columns", {}, {
      params: { table, requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(parameters, requestID) {
    return Service.post(resource + "save", parameters, {
      params: { requestID },
    });
  },
  get(aldID, requestID) {
    return Service.post(resource + "get", {}, {
      params: { aldID, requestID },
    });
  },
  delete(aldID, usrUpdateID, requestID) {
    return Service.post(resource + "delete", {}, {
      params: { aldID, usrUpdateID, requestID },
    });
  },
  validateFormula(formula, requestID) {
    return Service.post(resource + "validate", {}, {
      params: { requestID,formula },
      
    });
  },
  testFormula(formula, val, requestID) {
    return Service.post(resource + "test", {}, {
      params: { formula: formula, val: val, requestID: requestID },
    });
  },
  testFormulaMap(formula, values, requestID) {
    return Service.post(resource + "test-map", { formula, values }, {
      params: { requestID: requestID },
    });
  },
};
